module.exports = __webpack_public_path__ + "static/media/searchIcon.e41b74ba.svg";